import {
  WAREHOUSE_AREAS_INDEX_REQUESTED,
  WAREHOUSE_AREAS_INDEX_SUCCESS,
  WAREHOUSE_AREAS_INDEX_FAILURE,
  WAREHOUSE_AREAS_BREAKDOWN_REQUESTED,
  WAREHOUSE_AREAS_BREAKDOWN_SUCCESS,
  WAREHOUSE_AREAS_BREAKDOWN_FAILURE,
  WAREHOUSE_AREAS_FORGET_REQUESTED,
  WAREHOUSE_AREAS_FORGET_SUCCESS,
  WAREHOUSE_AREAS_FORGET_FAILURE,
  WAREHOUSE_LABEL_PRINT_REQUESTED,
  WAREHOUSE_LABEL_PRINT_SUCCESS,
  WAREHOUSE_LABEL_PRINT_FAILURE,
} from '../types';

const INITIAL_STATE = {
  areas: [],
  meta: { status: 'idle' },
  bpnSeparator: '-',
  downloadUrl: null,
  isFetching: false,
  isPrinting: false,
  status: 'waiting',
  errors: null
};

const warehouseAreas = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case WAREHOUSE_AREAS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        errors: null
      });

    case WAREHOUSE_AREAS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        areas: action.payload.areas || [],
        meta: action.payload.meta || { status: 'idle' },
        bpnSeparator: action.payload.bpn_separator || '-',
        isFetching: false,
        status: 'success',
        errors: null
      });

    case WAREHOUSE_AREAS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case WAREHOUSE_AREAS_BREAKDOWN_REQUESTED:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, { status: 'running' }),
        errors: null
      });

    case WAREHOUSE_AREAS_BREAKDOWN_SUCCESS:
      return state;

    case WAREHOUSE_AREAS_BREAKDOWN_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, { status: 'error' }),
        errors: action.error
      });

    case WAREHOUSE_AREAS_FORGET_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        errors: null
      });

    case WAREHOUSE_AREAS_FORGET_SUCCESS:
      return Object.assign({}, state, {
        areas: [],
        meta: { status: 'idle' },
        isFetching: false,
        status: 'success',
        errors: null
      });

    case WAREHOUSE_AREAS_FORGET_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case WAREHOUSE_LABEL_PRINT_REQUESTED:
      return Object.assign({}, state, {
        downloadUrl: null,
        isPrinting: true,
        errors: null
      });

    case WAREHOUSE_LABEL_PRINT_SUCCESS:
      return Object.assign({}, state, {
        downloadUrl: action.payload,
        isPrinting: false,
        errors: null
      });

    case WAREHOUSE_LABEL_PRINT_FAILURE:
      return Object.assign({}, state, {
        isPrinting: false,
        errors: action.error
      });

    default:
      return state;
  }
}

export default warehouseAreas;
